__turbopack_context__.v({
  "AuthorCardContent": "wrbMEa_AuthorCardContent",
  "author-booklist-header": "wrbMEa_author-booklist-header",
  "author-books": "wrbMEa_author-books",
  "author-details": "wrbMEa_author-details",
  "author-name": "wrbMEa_author-name",
});
